import React, { useMemo } from 'react';
import styles from './OutdoorImpact.module.css';
import { outdoorImpactFormatters } from './outdoorImpactFormat';
import { useOutdoorImpactData } from './useOutdoorImpactData';
import { CAMPAIGN_STATUS } from '../../../constants/enums.js';

// Renders Region subset from oiData: Region, Reach, Reach %, Frequency
// Expects oiData.data[0] as headers and remaining rows as values.
export default function OutdoorImpactRegionsTable({ orderOrderLineId, campaignStatus, alignWithFooterNote }) {
  const { formatValue } = outdoorImpactFormatters;
  const { oiData, loading, error } = useOutdoorImpactData(orderOrderLineId, campaignStatus);

  // Memoized subset computed EVERY render (even if we later early-return) to keep hook order stable.
  const subset = useMemo(() => {
    if (!oiData || !oiData.data || !Array.isArray(oiData.data) || oiData.data.length < 2) return null;
    const headers = oiData.data[0];
    const findIndex = name => headers.findIndex(h => h.toLowerCase() === name.toLowerCase());
    const idxRegion = findIndex('Region');
    const idxReach = findIndex('Reach');
    const idxReachPct = findIndex('Reach (%)');
    const idxFrequency = findIndex('Avg. Freq');
    return oiData.data.slice(1).map(row => ({
      region: row[idxRegion],
      reach: row[idxReach],
      reachPct: row[idxReachPct],
      frequency: row[idxFrequency]
    }));
  }, [oiData]);

  if (campaignStatus !== CAMPAIGN_STATUS.COMPLETED) {
    return (
      <div className={styles.messageContainer}>
        <div className={styles.messageWithoutCard}>
          <p className={styles.messageText}>This data will be shown after the end of the campaign</p>
        </div>
      </div>
    );
  }
  if (error) return <div className={styles.messageText}>Failed to load reach / frequency data.</div>;
  if (!subset) return null;

  return (
    <>
      {oiData && oiData.data && (
        <table 
            className={`${styles.oiTable} 
                        ${styles.oiTableFullWidthHeight} 
                        ${alignWithFooterNote ? styles.oiTableAspectRatioWithFootNote : styles.oiTableAspectRatio}`}>
          <thead>
            <tr>
              <th className={styles.oiHeader}>Region</th>
              <th className={styles.oiHeader}>Reach</th>
              <th className={styles.oiHeader}>Reach %</th>
              <th className={styles.oiHeader}>Frequency</th>
            </tr>
          </thead>
          <tbody>
            {subset.map((r, i) => (
              <tr key={i}>
                <td className={styles.oiCell}>{r.region}</td>
                <td className={styles.oiCell}>{formatValue(r.reach, 'Reach')}</td>
                <td className={styles.oiCell}>{formatValue(r.reachPct, 'Reach (%)')}</td>
                <td className={styles.oiCell}>{formatValue(r.frequency, 'Frequency')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}  
    </>
  );
}